/* globals _, moment */

import Trip from  './trip';
import Method from './method';

const { extend } = _;

export default Trip.extend( {
	key: 'itinerary',

	defaults: extend( Trip.prototype.defaults, {
		type: '',
		mode: '',
		title: 'My Custom Trip',
		date: null,
		start: null,
		end: null,
	} ),

	initialize: function() {
		Trip.prototype.initialize.apply( this, arguments );

		if ( ! this.get( 'date' ) ) {
			this.set( 'date', moment().format( 'YYYY-MM-DD' ) );
		}

		this.assignMethod();
		this.on( 'change:mode', this.assignMethod );
	},

	assignMethod: function() {
		this.method = new Method( this.get( 'mode' ) );
		this.set( 'area', this.method.get( 'radius' ) );
	},

	bindType: function( compare ) {
		return [
			'change:type',
			$elm => {
				$elm.toggleClass( 'hidden', this.get( 'type' ) !== compare );
			},
		];
	},

	bindDate: function() {
		return [
			'change:date',
			( $elm, options = {} ) => {
				var date = this.get( 'date' );

				$elm.removeClass( 'as-date' );
				switch ( date ) {
					case 'today':
						return 'Today';

					case 'tomorrow':
						return 'Tomorrow';

					case 'weekend':
						return 'This Weekend';

					default:
						$elm.addClass( 'as-date' );
						return moment( date ).format( options.format || 'MMMM Do, YYYY' );
				}
			},
		];
	},

	bindTime: function() {
		return [
			'change:start change:end',
			( $elm, options = {} ) => {
				var sep = options.sep || '-';
				return moment( this.get( 'start' ), 'HH:mm' ).format( 'ha' ) + sep + moment( this.get( 'end' ), 'HH:mm' ).format( 'ha' );
			},
		]
	},

	bindStart: function() {
		return [
			'change:start',
			() => moment( this.get( 'start' ), 'HH:mm' ).format( 'ha' ),
		];
	},

	bindEnd: function() {
		return [
			'change:end',
			() => moment( this.get( 'end' ), 'HH:mm' ).format( 'ha' ),
		];
	},

	bindCategory: function() {
		return [
			'change:category',
			( $elm, options = {} ) => {
				var use = options.use || 'name';

				$elm.attr( 'data-icon', this.category.get( 'slug' ) );

				return this.category.get( use );
			},
		];
	},

	bindMode: function() {
		return [
			'change:mode',
			( $elm, options = {} ) => {
				var use = options.use || 'name';

				$elm.attr( 'data-icon', this.method.get( 'slug' ) );

				return this.method.get( use );
			},
		];
	},
} );
